export default __webpack_public_path__ + "static/media/logo_atlass.1a0e3a5a.png";